
import React, {  useState } from "react";
import DetayModal from "./../detay/DetayModal";
import ProductItems from "./ProductItems";
import {
 
  PortfolioContainer,
  
  ProductTitle,
  PortfolioWrapper,
  
} from "./styles";





const Portfolio =  ({id,title,data}) => {
 
 // console.log(title)
  const [showModal, setShowModal] = useState(false);
  const [ResAl, setResAl] = useState(null);
  const [resims, setResims] = useState(null);
  const [dataz, setData] = useState([]);
  
  const openModal = (prev,res,resim,datax) => {
   // console.log(showModal)
  //  console.log(datax);
    setResAl(res);
    setData(datax);
    setResims(resim)
    setShowModal(prev => !prev);
  };
  

  
    

  return (
    <PortfolioWrapper>
      <ProductTitle>{title}</ProductTitle>
    
      <PortfolioContainer>
       {data && data.map((item,index) => (
           <ProductItems
           id={id}
           item={item}
           openModal={openModal}
           key={index}
           />
          
        ))}
      </PortfolioContainer>
     
      <DetayModal id={id} res={ResAl} resim={resims} dataa={dataz} showModal={showModal} setShowModal={setShowModal} /> 
    
    </PortfolioWrapper>

 
  );
};

export default Portfolio;
